module.exports = __webpack_public_path__ + "static/media/mt5.cee86185.jpg";